import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import useMedia from "use-media";
import { Label } from "../../atoms/label";
import { ModalClose } from "../../atoms/modalClose";
import { ErrorMassage } from "../../molecules/errorMassage";
import "../../../resources_membership_hotel/css/popup/roomList.css"
import { getServiceCheck } from "../../../const";
import common from "../../../resources/js/common/common";
const RoomListPopupContainer = (props) => {
    const {
        state,
        inputRoomList,
        setInputRoomList,
        setServiceCheckInfo,
        membershipSearchParam,
        membershipReserveInfo,
        inputUserInfo,
        onClickClosePopupWindow,
        onClickOpenRoomDetailPopup,
        setInputUserInfo,
    } = props;
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupMode = state.popupMode;
    let roomData = state.roomData;
    const popupRef = useRef(null);
    const [errorInfo, setErrorInfo] = useState({ errorFlg: false, errorMessageBox: [] });

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);
    useEffect(() => {
        popupRef.current.scrollTop = 0;
        setErrorInfo({ errorFlg: false, errorMessageBox: [] });
    }, [popupMode, state.membershipPopup]);


    const onClickRoom = (room) => {
        let newInputRoomList = [...inputRoomList]
        let targetRoom = newInputRoomList[state.roomIndex];
        targetRoom.roomType = room.roomTypeCd;
        targetRoom.roomTypeName = room.hyojiyoRoomTypeNam;
        targetRoom.roomDayList = room.roomDayList;
        if (membershipReserveInfo.machiFlg != "0" && membershipSearchParam.nights > 1 && room.roomDayList?.length) {
            const targetList = room.roomDayList.filter(value => value.zanRoom !== 0);
            if (targetList.length === 0) {
                targetRoom.machiLabel = "※全日空きなし";
            } else if (targetList.length < room.roomDayList.length) {
                targetRoom.machiLabel = "※一部空きあり";
            } else {
                targetRoom.machiLabel = "";
            }
        } else {
            targetRoom.machiLabel = "";
        }

        let machiMongon = "";
        if(newInputRoomList && newInputRoomList.length > 0){
            for(let selectRoomInfo of newInputRoomList) {
                if(membershipReserveInfo.machiFlg === '1'){
                    if(selectRoomInfo.machiLabel.indexOf('一部') !== -1){
                        machiMongon = '一部交換待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
                        break;
                    } else{
                        machiMongon = '交換待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
                    }
                }else if(membershipReserveInfo.machiFlg === '2'){
                    if(selectRoomInfo.machiLabel.indexOf('一部') !== -1){
                        machiMongon = "一部キャンセル待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。";
                        break;
                    }else{
                        machiMongon = 'キャンセル待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
                    }
                }
            }
        }
        setInputUserInfo({...inputUserInfo,machiMongon:machiMongon})
        setInputRoomList(newInputRoomList);

        // 予約部屋数取得
        const roomTypeCdList = [];
        let roomTypeSelected = true;
        newInputRoomList.forEach(value => {
            const roomType = value.roomType;
            if (roomType === "") {
                // 未選択時はListに追加しない
                roomTypeSelected = false;
                return;
            }
            const roomTypeCd = roomTypeCdList.find(x => x.roomTypeCd === roomType);
            if (roomTypeCd) {
                roomTypeCd.yoyakuRoomSu += 1;
            } else {
                roomTypeCdList.push({
                    roomTypeCd: roomType,
                    yoyakuRoomSu: 1
                });
            }
        });
        if (!roomTypeSelected || !inputUserInfo?.relationCd) {
            // お部屋タイプ、続柄が未選択時はAPIを呼び出さない
            setServiceCheckInfo({});
            onClickClosePopupWindow();
            return;
        }
        // サービスチェック取得
        const req = {
            keiyakuNo: membershipSearchParam.keiyakuNo,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            riyoDate: membershipSearchParam.checkInDate,
            hakuCnt: membershipSearchParam.nights,
            tsuzukigaraCd: inputUserInfo?.relationCd,
            roomTypeList: roomTypeCdList,
            riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
        }
        common.doPost(getServiceCheck, req, afterGetServiceCheck);
    }

    // サービスチェック取得後処理
    const afterGetServiceCheck = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setServiceCheckInfo({
                kozafurikaeKanoKbn: data.kozafurikaeKanoKbn,
                kozafurikaeKiyakuMongon: data.kozaMongon,
                sciKanoFlg: data.sciKanoFlg,
                sciKiyakuMongon: data.sciMongon,
                scoKanoFlg: data.scoKanoFlg,
                scoKiyakuMongon: data.scoMongon,
                nonstopCheckInKanoFlg: data.nonstopCheckinKanoFlg,
                nonstopKiyakuMongon: data.nonstopMongon,
                kenrishokaYoFlg: data.kenrishokaYoFlg,
                homeFlKanoFlg: data.homeFlKanoFlg
            });
        }
        onClickClosePopupWindow();
    }

    const onClickRoomName = (e, room) => {
        e.stopPropagation();
        onClickOpenRoomDetailPopup(room);
    }

    const getMachiLabel = (roomDayList) => {
        if (!roomDayList) {
            return ""
        }
        const targetList = roomDayList.filter(value => value.zanRoom !== 0);
        if (targetList.length === 0) {
            return "※全日空きなし";
        } else if (targetList.length === roomDayList.length) {
            return ""
        } else {
            return "※一部空きあり"
        }
    }

    return (
        <div className={state.roomPopup ? "restaurantPopupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={isMobilePhone ? "inputUserPopupInner_media" : "inputUserPopupInner"}>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickClosePopupWindow} />
                    <h4 className="popupInnerText" >お部屋タイプ</h4>
                </div>
                <div className={errorInfo.errorFlg ? "errorDiv" : "hiddenItem"}>
                    <ErrorMassage data={errorInfo.errorMessageBox} />
                </div>
                <div className="roomListWrapper">
                    {roomData?.map((room, index) =>
                        <>
                            {membershipSearchParam.nights > 1 ?
                                <Label
                                    label={getMachiLabel(room.roomDayList)}
                                    className={"roomList_machiLabel"}
                                />
                                : null
                            }
                            <div className={"roomInfoWrapper " +
                                (membershipReserveInfo.machiFlg != "0" && !getMachiLabel(room.roomDayList) ? "machiDisabledClass " : "") +
                                (room.hikasseiFlg ? "" : "pointerClass")} onClick={() => membershipReserveInfo.machiFlg != "0" ? (!getMachiLabel(room.roomDayList) ? null : onClickRoom(room)) : (room.hikasseiFlg ? null : onClickRoom(room))}>
                                <div className="roomInfo">
                                    <div>
                                        <Label
                                            label={`${room.roomGradeNam}`}
                                            className="gradeLabel"
                                        />
                                    </div>
                                    <a className={"roomNameLabel " + (room.roomTypeGazoList?.length ? "blueLink" : "")} onClick={(e) => room.roomTypeGazoList?.length ? onClickRoomName(e, room) : null}>{room.roomTypeCdNam}</a>
                                    <div className="roomInfoIconList">
                                        {room.mensekiMin || room.mensekiMax ?
                                            <Label
                                                label={room.mensekiMin == room.mensekiMax || (room.mensekiMin && !room.mensekiMax) ? `${room.mensekiMin}平米`
                                                    : (!room.mensekiMin && room.mensekiMax) ? `${room.mensekiMax}平米`
                                                        : `${room.mensekiMin}～${room.mensekiMax}平米`}
                                                className="roomInfoIcon"
                                            />
                                            : null
                                        }
                                        {room.kinenFlg ?
                                            <Label
                                                label="禁煙"
                                                className="roomInfoIcon"
                                            />
                                            : null
                                        }
                                        {room.dogDohanFlg ?
                                            <Label
                                                label="愛犬可"
                                                className="roomInfoIcon"
                                            />
                                            : null
                                        }
                                        {room.roomOnsenFlg ?
                                            <Label
                                                label="温泉付"
                                                className="roomInfoIcon"
                                            />
                                            : null
                                        }
                                    </div>
                                    <div className="priceAndCapacity">
                                        {room.roomPrice ?
                                            <Label
                                                label={`料金：￥${room.roomPrice ? room.roomPrice?.toLocaleString() : 0}（税込）`}
                                                className="roomPriceLabel"
                                            /> :
                                            <div className="">
                                                <Label
                                                    label={`メンバー料金：￥${room.roomPriceMmb ? room.roomPriceMmb?.toLocaleString() : 0}（税サ込）`}
                                                    className="roomPriceLabel"
                                                />
                                                <Label
                                                    label={`ゲスト料金：￥${room.roomPriceGuest ? room.roomPriceGuest?.toLocaleString() : 0}（税サ込）`}
                                                    className="roomPriceLabel"
                                                />
                                            </div>
                                        }
                                        <Label
                                            label={`${room.hyojiyoTeiin}名`}
                                        />
                                    </div>
                                </div>
                                <Label
                                    label={membershipReserveInfo.machiFlg != "0" && !getMachiLabel(room.roomDayList) ? "" : room.hikasseiFlg ? "満室" : "選択"}
                                    className={membershipReserveInfo.machiFlg != "0" && !getMachiLabel(room.roomDayList) || room.hikasseiFlg ? "mansekiLabel" : "roomList_selectBtn"}
                                />
                            </div>
                            <div className="roomInfoBorder" />
                        </>
                    )}
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        inputUserInfo: state.inputUserInfo,
        inputRoomList: state.inputRoomList,
        membershipSearchParam: state.membershipSearchParam,
        membershipReserveInfo: state.membershipReserveInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setInputRoomList: (item) => {
            dispatch({ type: "INPUT_ROOM_LIST", payload: { inputRoomList: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setServiceCheckInfo: (item) => {
            dispatch({ type: "SERVICE_CHECK_INFO", payload: { serviceCheckInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RoomListPopupContainer);